import { REDUCER_NAME } from './const'
import reducer from './reducer'

export {
    reducer,
    REDUCER_NAME,
}




// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/index.js